
<div class="file-uploader">
  <!-- selector -->
  @if (isEditable) {
    <div class="file-uploader__file-selector">
      <input type="file"
        matInput
        (change)="onFileChanged($any($event.currentTarget).files)"
        [multiple]="isMultiple"
        hidden
        [accept]="accept"
        #fileUpload>
        <button (click)="fileUpload.click()" mat-raised-button color="primary">
          <mat-icon>cloud_upload</mat-icon>
          {{label}}
          @if (required) {
            <span class="sc-required sc-required-star"></span>
          }
        </button>
        @if(accept) {
          <span class="file-uploader__file-selector__accepted-formats">(Accepted files: {{ accept }})</span>
        }
        @if(maxFileSize) {
          <span class="file-uploader__file-selector__accepted-formats">(Max file size: {{ (maxFileSize / 1024 / 1024).toFixed(2) }} MB)</span>
        }
      </div>
    }

    <!-- current file (already from init + selected) -->
    @for (file of files; track file) {
      <div class="file-uploader__file-item">
        <div class="file-uploader__file-item__content">
          @if (file.isWaiting) {
            <span>Please wait...</span>
          }
          <div class="file-uploader__file-item__content__file-icon">
            <mat-icon>attach_file</mat-icon>
          </div>
          <div class="file-uploader__file-item__content__info">
            <!-- file name + size -->
            @if (file.fileName) {
              <p class="file-uploader__file-item__content__info__file-name">{{ file.fileName }}</p>
            }
            @if (file.fileSize) {
              <p class="file-uploader__file-item__content__info__file-size">{{ (file.fileSize / 1024 / 1024).toFixed(2) }} MB</p>
            }
          </div>
          <!-- download button -->
          @if (file.downloadUrl && !file.isUploading) {
            <a [href]="file.downloadUrl" download target="_self" mat-icon-button>
              <mat-icon>download</mat-icon>
            </a>
          }
          <!-- remove file -->
          @if (isEditable && !file.isUploading && !file.isWaiting) {
            <button mat-icon-button
              (click)="onRemoveFile(file)">
              <mat-icon>delete_forever</mat-icon>
            </button>
          }
        </div>
        <!-- upload progress -->
        @if (file.isUploading) {
          <div class="file-uploader__upload-progress">
            <div class="file-uploader__upload-progress__progress-percentage">
              Uploading...{{ file.uploadedPercentage + '%' }}
              <mat-progress-bar mode="determinate"
              [value]="file.uploadedPercentage"></mat-progress-bar>
            </div>
            <button mat-icon-button (click)="onCancelUpload(file)">
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        }
      </div>
    }
  </div>
